import PropTypes from 'prop-types';
import { createContext, useContext, useLayoutEffect, useState } from 'react';

export const ViewportSizerContext = createContext(null);
ViewportSizerContext.displayName = 'ViewportSizerContext';

export const ViewportSizerProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  let narrowScreen = width < 1200;

  useLayoutEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <ViewportSizerContext.Provider value={{ width, narrowScreen }}>
      {children}
    </ViewportSizerContext.Provider>
  );
};

ViewportSizerProvider.propTypes = {
  children: PropTypes.node,
};

export const useViewportSizer = () => useContext(ViewportSizerContext);
